<template>
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.25 12.9477C10.5395 12.9477 13.2008 10.2819 13.2008 7C13.2008 3.71807 10.5395 1.05227 7.25 1.05227C3.96054 1.05227 1.29918 3.71807 1.29918 7C1.29918 10.2819 3.96054 12.9477 7.25 12.9477ZM7.25 14C11.116 14 14.25 10.866 14.25 7C14.25 3.13401 11.116 0 7.25 0C3.38401 0 0.25 3.13401 0.25 7C0.25 10.866 3.38401 14 7.25 14Z"
      :fill="props.fill"
    />
    <path
      d="M6.65085 5.27665H7.87489V10.5212H6.65085V5.27665ZM7.26776 4.41239C7.0458 4.41239 6.85975 4.34364 6.7096 4.20614C6.55945 4.0621 6.48438 3.88532 6.48438 3.6758C6.48438 3.46628 6.55945 3.29277 6.7096 3.15527C6.85975 3.01123 7.0458 2.93921 7.26776 2.93921C7.48972 2.93921 7.67578 3.00796 7.82593 3.14545C7.97608 3.2764 8.05115 3.44336 8.05115 3.64633C8.05115 3.8624 7.97608 4.04573 7.82593 4.19632C7.68231 4.34037 7.49625 4.41239 7.26776 4.41239Z"
      :fill="props.fill"
    />
  </svg>
</template>

<script setup>
const props = defineProps({
  fill: {
    type: String,
    default: "#1E2648",
  },
});
</script>
